<template>
  <TemplateView>
    <v-btn absolute bottom @click="copy" style="z-index: 5" icon class="mb-n10 mt-10">.</v-btn>
    <ChatModal
      @close-dialog="onCloseDialog"
      :usersList="usersList"
      :chats="chatsListFormatted"
      :chatSelect="chatSelect"
      ref="chatModal"
      :chatTranslations="chatTranslations"
    />
    <ChatUnsupportedFilesModal/>
    <ChatModalKicked :chatTranslations="chatTranslations"/>
    <div class="container">
      <div class="chat d-grid grid-row-1 gap-5" v-resize="onResize">
        <div
          class="chat__col gap-4"
          v-show="$vuetify.breakpoint.smAndDown ? !$route.params.id : true"
        >
          <Search maxWidth="100%" v-model="search" routeQuery/>
          <ChatBox scroll @scroll="scrollChatList" border-radius="10px" class="grid-row-1-max">
            <ChatList
              :chats="chatsListFormatted"
              :search="search"
              :chatTranslations="chatTranslations"
            />
            <div class="chatList_button pa-5 d-flex justify-self-end">
              <v-menu
                v-model="menu"
                top
                offset-y
                :offset-x="true"
                :close-on-content-click="true"
                content-class="white menu__content"
              >
                <template v-slot:activator="{}">
                  <BaseButton
                    size="48"
                    default_icon="button-add-v2"
                    icon_only
                    round
                    @click="menu = true"
                  />
                </template>
                <BaseList :items="items" uppercase/>
              </v-menu>
            </div>
          </ChatBox>
        </div>
        <Transition>
          <div
            class="chat__col gap-2"
            v-if="chatSelect"
            v-show="$vuetify.breakpoint.smAndDown ? $route.params.id : true"
            @dragover="dragover"
            @dragleave="dragleave"
            @drop="drop"
            :class="{ isDragging }"
          >
            <ChatBox>
              <ChatHeader
                :chatItem="chatSelect"
                @click="onClickHeader"
                :chatTranslations="chatTranslations"
                :onChatModalOpen="onChatModalOpen"
              />
            </ChatBox>
            <ChatBox scroll @scroll="correspondenceBoxScroll" ref="correspondenceBox">
              <ChatCorrespondence
                :chatItem="chatSelect"
                :onFindUserById="onFindUserById"
                @messagesInWatchNow="onMessagesInWatchNow"
                :onChatModalOpen="onChatModalOpen"
              />
            </ChatBox>
            <ChatCorrespondenceUnseenButton :chat-item="chatSelect" :visible="scrollButtonVisible"/>
            <ChatInputField
              v-show="chatSelect.actionEnabled"
              :chatItem="chatSelect"
            />
          </div>
        </Transition>
      </div>
    </div>
    <!-- <LoadingAnimation v-else /> -->
  </TemplateView>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'

import TemplateView from 'components/templates/TemplateView'
import Search from 'components/Search'
import ChatList from 'components/chat/ChatList'
import ChatBox from 'components/chat/ChatBox'
import ChatHeader from 'components/chat/ChatHeader'
import ChatCorrespondence from 'components/chat/correspondence/ChatCorrespondence'
import ChatModal from 'components/chat/modal/ChatModal'
import ChatUnsupportedFilesModal from 'components/chat/files/ChatUnsupportedFilesModal'
import ChatModalKicked from 'components/chat/modal/ChatModalKicked'
import ChatInputField from 'components/chat/ChatInputField'
import ChatCorrespondenceUnseenButton from "components/chat/correspondence/ChatCorrespondenceUnseenButton.vue";

export default {
  name: 'chat',
  components: {
    ChatCorrespondenceUnseenButton,
    TemplateView,
    Search,
    ChatList,
    ChatBox,
    ChatHeader,
    ChatCorrespondence,
    ChatModal,
    ChatUnsupportedFilesModal,
    ChatModalKicked,
    ChatInputField,
  },
  data() {
    return {
      search: '',
      files: [],
      menu: false,
      watchMessageSend: false,
      scrollChatListY: 0,
      scrollChatItemY: 0,
      scrollButtonVisible: false,
      messagesInWatchNow: [],
      windowSize: {
        x: 0,
        y: 0,
      },
      isDragging: false,
    }
  },
  created() {
    this.downloadPageData()
  },

  mounted() {
    this.onResize()
    this.onWatchMessageSend()
  },
  computed: {
    ...mapState(['configData']),
    ...mapGetters(['loadingAnimation']),
    ...mapState('commonUser', ['commonUserAll']),
    ...mapGetters('user', ['userData']),
    ...mapGetters('chat', ['chatsListFormatted']),
    ...mapState('chat', ['chatSocketIo']),
    chatSelect() {
      return Array.isArray(this.chatsListFormatted) && this.$route.params.id
        ? this.chatsListFormatted.find((i) => i.id === this.$route.params.id)
        : null
    },
    usersList() {
      return this.commonUserAll
    },
    chatTranslations() {
      return (
        this.localStorage.translations.pages.chat && this.localStorage.translations.pages.chat.all
      )
    },
    items() {
      return [
        {
          title: this.chatTranslations.write_message,
          click: () => this.onChatModalOpen({type: 'PERSONAL', action: 'create'}),
        },
        {
          title: this.chatTranslations.create_group,
          click: () => this.onChatModalOpen({type: 'GROUP', action: 'create'}),
        },
      ]
    },
  },
  methods: {
    ...mapActions('commonUser', ['GET_commonUserAll']),
    ...mapActions('chat/messages', ['GET_chatAdditionalMessageById']),
    ...mapActions('chat/file', ['DROP_chatFileSelect']),
    copy() {
      try {
        const data = {
          chat_token: this.$cookies.get('chat_token'),
          proapp_token: this.$cookies.get('token'),
          userId: this.userData.id,
          chatList: this.chatsListFormatted,
        }
        navigator.clipboard.writeText(JSON.stringify(data))
      } catch (e) {
        throw e
      }
    },
    onChatModalOpen(params) {
      this.$refs.chatModal && this.$refs.chatModal.onOpen(params)
    },
    onWatchMessageSend() {
      if (
        this.chatSocketIo &&
        !this.watchMessageSend
      ) {
        console.log('onWatchMessageSend')
        this.chatSocketIo.on('message.sent', (resp) => {
          if (resp.chat.id === this.$route.params.id) {
            this.$nextTick(function () {
              this.onScrollToLastMessage(resp)
            })
          }
        })
        this.watchMessageSend = true
      }
    },
    onScrollToLastMessage(resp) {
      // resp = {chat,message,previousMessage}
      // console.log('onScrollToLastMessage')
      let messagesContainer = this.$refs.correspondenceBox && this.$refs.correspondenceBox.$el
      const lastMessage = this.chatSelect.lastMessage
      const previousMessage = this.chatSelect.messages[this.chatSelect.messages.length - 1]
      if (messagesContainer) {
        if (
          this.chatSelect.messages.length &&
          (lastMessage.senderId === this.userData.id ||
            (previousMessage?.isSeen && this.messagesInWatchNow.indexOf(previousMessage.id) > -1))
        ) {
          messagesContainer.scroll({
            top: messagesContainer.scrollHeight + 10,
            behavior: 'smooth',
          })
        }
      }
    },
    correspondenceBoxScroll(e) {
      //console.log('e.target', e.target )
      const loadingData = ({order, lastMessageId}) => {
        const scrollTopMax = e.target.scrollTopMax || e.target.scrollHeight - e.target.clientHeight
        this.GET_chatAdditionalMessageById({
          chatId: this.$route.params.id,
          lastMessageId,
          order,
        }).then(() => {
          if (order === 'desc') {
            this.$nextTick(function () {
              e.target.scrollTo({
                top:
                  (e.target.scrollTopMax || e.target.scrollHeight - e.target.clientHeight) -
                  scrollTopMax,
              })
            })
          }
        })
      }
      const scrolled = e.target.scrollTop
      const dY = scrolled - this.scrollChatItemY
      const scrollOnBottom = scrolled >= e.target.scrollHeight - e.target.clientHeight && this.chatSelect.messages.length

      this.scrollButtonVisible =
        (e.target.scrollHeight === e.target.clientHeight) ||
        (e.target.scrollTop + e.target.clientHeight + 40 > e.target.scrollHeight)
          ? false
          : dY > 0.7 && !scrollOnBottom
      this.scrollChatItemY = scrolled

      if (scrolled === 0 && this.chatSelect.messages.length) {
        const lastMessageId = this.chatSelect.messages[0].id
        loadingData({order: 'desc', lastMessageId})
      } else if (scrollOnBottom) {
        const lastMessageId = this.chatSelect.messages[this.chatSelect.messages.length - 1].id
        if (typeof lastMessageId === 'number' && lastMessageId !== this.chatSelect.lastMessage.id) {
          loadingData({order: 'asc', lastMessageId})
        }
        this.scrollButtonVisible = false
      }
    },
    scrollChatList(e) {
      const targetDiv = e.target.querySelector('.chatList_button')
      const scrolled = e.target.scrollTop
      const dY = scrolled - this.scrollChatListY
      if (dY > 0) {
        targetDiv.style.bottom = '-' + targetDiv.scrollHeight + 'px'
      } else {
        targetDiv.style.bottom = '0px'
      }
      this.scrollChatListY = scrolled
    },
    onClickHeader(value) {
      this.$refs.chatModal.onOpen(value)
    },
    onCloseDialog() {
      this.menu = false
    },
    onKeyDown(e) {
      console.log(e)
    },
    onFindUserById({userId}) {
      let result = null
      if (Array.isArray(this.usersList) && this.usersList.length && userId) {
        result = this.usersList.find((i) => i.id === userId)
      }
      return result
    },
    downloadPageData() {
      this.GET_commonUserAll()
    },
    onMessagesInWatchNow(value) {
      // console.log('onMessagesInWatchNow', value)
      this.messagesInWatchNow = value
    },
    onSearchCurrentUserIsCurrentChat(chat) {
      let currenUser = null
      if (chat && chat.participants) {
        currenUser = chat.participants.find((i) => i.userId === this.userData.id) || null
      }
      return currenUser
    },
    onResize() {
      this.windowSize = {x: window.innerWidth, y: window.innerHeight}
    },
    dragover(e) {
      // console.log('dragover')
      e.preventDefault()
      this.isDragging = true
    },
    dragleave() {
      // console.log('dragleave')
      this.isDragging = false
    },
    drop(e) {
      // onsole.log('drop')
      this.DROP_chatFileSelect(e)
      this.isDragging = false
    },
  },
}
</script>

<style lang="scss" scoped>
.chat {
  grid-template-columns: 450px 1fr;
  height: calc(100vh - (55px + 60px + 60px));
  @media screen and (max-width: 959px) {
    grid-template-columns: 1fr;
  }

  &__col {
    display: grid;
    height: 100%;
    align-content: start;
    max-height: calc(100vh - (55px + 60px + 60px));
    grid-template-rows: max-content 1fr;
    position: relative;

    .chatList_button {
      position: sticky;
      bottom: 0px;
      right: 0px;
      width: max-content;
      transition: bottom 0.2s ease-out 0s;
    }

    &.isDragging {
      &::before {
        content: url(./drag-drop-svg.svg);
        border: 3px dashed #277faf;
        border-radius: 10px;
        position: absolute;
        width: calc(100% + 10px);
        height: calc(100% + 10px);
        top: -5px;
        left: -5px;
        right: -5px;
        bottom: -5px;
        display: flex;
        justify-content: center;
        align-items: center;
        backdrop-filter: blur(2px);
        z-index: 10;
      }
    }
  }

  &__edit {
    grid-template-columns: 1fr 30px;
    border-bottom: 1px solid #e0e0e0;

    &__main {
      grid-template-columns: 30px 1fr;
      gap: inherit;
      cursor: pointer;
      user-select: none;
    }

    &__icon:deep() {
      svg {
        width: 100%;
        height: auto;
      }
    }

    &__text {
      white-space: nowrap; /* Запрещаем перенос строк */
      overflow: hidden; /* Обрезаем все, что не помещается в область */
      text-overflow: ellipsis;
    }
  }

  &__input {
    border-radius: 0px 0px 10px 10px;

    &__send {
      line-height: 1;
    }

    :deep() .v-input .v-input__slot:not(.v-textarea) fieldset {
      color: #c8c8c8 !important;
      border: 1px solid transparent !important;
    }
  }
}

.menu__content:deep() {
  border-radius: 8px !important;
  box-shadow: 0px 0px 16px rgba(182, 182, 182, 0.4);
}
</style>
